import { CloseCircleOutlined, DownloadOutlined, EditOutlined, CheckOutlined , FileDoneOutlined, FileTextOutlined} from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import ModalDescargarDocumentos from "../../../Components/ModalDescargarDocumentos";
import descargarDocumentosMasivo, { MODULOS } from "../../../Components/DescargarDocumentosMasivo";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class Requisiciones extends Component {
  tableRef = null;
  state = {
    idEditarRequisicion: null,
    todasRequisiciones: [],
    loading: false,
    valor: 1,
    requisicionesSeleccionadas: [],
    objetoRequisicionesEncontradas: [],
    modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } },
  };

  abrirDescarga() {
    this.setState({ modalDescarga: { visible: true, loading: false, progreso: { hechos: 0, total: 0 } } });
  }

  cerrarDescarga() {
    this.setState({ modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } } });
  }

  async confirmarDescarga(formatos) {
    this.setState((prev) => ({ modalDescarga: { ...prev.modalDescarga, loading: true } }));
    await descargarDocumentosMasivo({
      modulo: "requisicion",
      ids: this.state.requisicionesSeleccionadas,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      ...formatos,
      onProgreso: (hechos, total) => this.setState((prev) => ({
        modalDescarga: { ...prev.modalDescarga, progreso: { hechos, total } },
      })),
    });
    this.cerrarDescarga();
  }
  consultarRequisiciones(params) {
    this.setState({ loading: true });
    axios
      .post(
        "requisiciones/selectTodasRequisiciones",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todasRequisiciones: [] });
        } else {
          this.setState({
            todasRequisiciones: res.data.data.map((data) => {
              return {
                ...data,
                accion: {
                  estado: data.estado,
                  _id: data._id,
                  finiquitada: data.finiquitada,
                },
                solicitante: (data?.solicitante?.nombre || "") + " " + (data?.solicitante?.apellidoPaterno || "") + " " + (data?.solicitante?.apellidoMaterno || ""),
                proyecto: data.proyecto.nombre,
              };
            }),
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  cancelarRequisicion(value) {
    axios
      .post(
        "requisiciones/cancelarRequisicion",
        { requisicionId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Requisicion cancelada");
        } else if (res.data.success === 1) {
          message.warning(res.data.message ? res.data.message : "Hubo un error");
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
      });
  }
  agregarRequisicion() {
    this.props.history.push("/panel/agregarRequisicion");
  }
  editarRequisicion(id) {
    this.props.history.push("/panel/editarRequisicion", { id });
  }
  verRequisicion(id) {
    this.props.history.push("/panel/verRequisicion", { id });
  }
  generarOrdenDeCompra(id) {
    this.props.history.push("/panel/generarOrdenDeCompraConRequisicion", { id });
  }
  mandarWorkBench(id) {
    this.props.history.push("/panel/mandarWorkBench", { id });
  }
  cotizacionesRequisicion(id) {
    this.props.history.push("/panel/cotizacionesRequisicion", { id });
  }

  // La selección es libre: cualquier requisición se puede marcar, porque también
  // alimenta la descarga masiva. La regla de "solo pendientes" se valida al usar
  // Agrupar Requisiciones.
  onSelectChange = (requisicionesSeleccionadas) => {

    let encontrarRequisiciones = [];

    for (const requisicionId of requisicionesSeleccionadas) {
      const yaGuardada = this.state.objetoRequisicionesEncontradas.find(c => c._id?.toString() === requisicionId);
      if (yaGuardada) continue;
      const requisicion = this.state.todasRequisiciones.find(c => c._id?.toString() === requisicionId);
      if (requisicion) encontrarRequisiciones.push(requisicion);
    }

    this.setState({ requisicionesSeleccionadas, objetoRequisicionesEncontradas: [...this.state.objetoRequisicionesEncontradas, ...encontrarRequisiciones] });
  }

  // Devuelve true si la selección se puede agrupar, o false si alguna no aplica
  // (ya se avisó al usuario).
  requisicionesParaAgrupar() {
    const { requisicionesSeleccionadas } = this.state;
    if (requisicionesSeleccionadas.length === 0) {
      message.warn("No hay requisiciones seleccionadas");
      return false;
    }

    for (const requisicionId of requisicionesSeleccionadas) {
      let requisicion = this.state.todasRequisiciones.find(c => c._id?.toString() === requisicionId);
      if (!requisicion) {
        requisicion = this.state.objetoRequisicionesEncontradas.find(c => c._id?.toString() === requisicionId);
      }
      if (!requisicion) {
        message.warn("No se encontró la requisición seleccionada");
        return false;
      }
      if (requisicion.estado !== 1) {
        message.warn("Solo se pueden agrupar requisiciones pendientes");
        return false;
      }
    }

    return true;
  }

  agruparRequisiciones() {
    const { requisicionesSeleccionadas } = this.state;
    if (!this.requisicionesParaAgrupar()) return;
    this.setState({ loading: true });

    axios
      .post(
        "requisiciones/agruparRequisiciones",
        { requisicionesSeleccionadas: requisicionesSeleccionadas, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se agrego la requisicion " + res.data.codigo);
          this.setState({ requisicionesSeleccionadas: [] });
        } else if (res.data.success === 1) {
          message.warning(res.data.message ? res.data.message : "Hubo un error");
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
      });

  }

  finiquitarRequisicion(id) {
    axios
      .post(
        "requisiciones/finiquitarRequisicion",
        { requisicionId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Requisicion finiquitada");
        } else {
          message.error(res.data.message || "Sucedio un error y no se pudo finiquitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Numero",
        dataIndex: "numero",
        key: "numero",
        buscar: "numero",
        width: "9%",
      },
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('L'),
        width: '10%',
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto < b.proyecto) {
            return -1;
          }
          if (a.proyecto > b.proyecto) {
            return 1;
          }
          return 0;
        },
        buscar: "proyecto",
        width: "17%",
      },
      {
        title: "Solicitante",
        dataIndex: "solicitante",
        key: "solicitante",
        buscar: "solicitante",
        width: "15%",
      },
      {
        title: "Observaciones",
        dataIndex: "observaciones",
        key: "observaciones",
        sorter: (a, b) => {
          if (a.observaciones < b.observaciones) {
            return -1;
          }
          if (a.observaciones > b.observaciones) {
            return 1;
          }
          return 0;
        },
        buscar: "observaciones",
        width: "33%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (value, index) => {
          if (value === 0) {
            return <Tag color="red" className="square-tag">Cancelada</Tag>;
          }
          if (value === 1) {
            return <Tag color="orange" className="square-tag">Pendiente</Tag>;
          }
          if (value === 2) {
            return <Tag color="lime" className="square-tag">En proceso</Tag>;
          }
          if (value === 3) {
            return <Tag color="green" className="square-tag">Terminada</Tag>;
          }
        },
        width: "13%",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "25%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          const puedeGenerarOrden = this.props.permisoGenerarOCReq && (value.estado === 1 || value.estado === 2);
          buttons.push(
            <Tooltip title={puedeGenerarOrden ? "Generar Orden" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`generar-orden-${index}`}
                type="default"
                size="small"
                azul
                icon={<CheckOutlined />}
                onClick={() => puedeGenerarOrden && this.generarOrdenDeCompra(value._id)}
                disabled={!puedeGenerarOrden}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeCotizar = this.props.permisoCotizacionesRequisicion && (value.estado === 1 || value.estado === 2);
          buttons.push(
            <Tooltip title={puedeCotizar ? "Solicitud de Cotización" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`cotizaciones-${index}`}
                type="default"
                size="small"
                morado
                icon={<FileTextOutlined />}
                onClick={() => puedeCotizar && this.cotizacionesRequisicion(value._id)}
                disabled={!puedeCotizar}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeWorkBench = (value.estado === 1 || value.estado === 2) &&  (this.props.workbenchRequisiciones);
          buttons.push(
            <Tooltip title={puedeWorkBench ? "WorkBench" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`workbench-${index}`}
                type="default"
                size="small"
                blanco
                onClick={() => puedeWorkBench && this.mandarWorkBench(value._id)}
                disabled={!puedeWorkBench}
              >
                W
              </ButtonItem>
            </Tooltip>
          );

          const puedeFiniquitar = value.estado === 2;
          buttons.push(
            <Popconfirm
              key={`finiquitar-${index}`}
              title="Seguro que quieres finiquitar esta requisición"
              onConfirm={() => this.finiquitarRequisicion(value._id)}
              okText="Si"
              cancelText="No"
              disabled={!puedeFiniquitar}
            >
              <Tooltip title={puedeFiniquitar ? "Finiquitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  naranja
                  icon={<FileDoneOutlined />}
                  disabled={!puedeFiniquitar}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          const puedeEditar = this.props.permisoEditarRequisiciones && value.estado === 1;
          buttons.push(
            <Tooltip title={puedeEditar ? "Editar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`editar-${index}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => puedeEditar && this.editarRequisicion(value._id)}
                disabled={!puedeEditar}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeCancelar = this.props.permisoCancelarRequisiciones && value.estado === 1 ;
          buttons.push(
            <Popconfirm
              key={`cancelar-${index}`}
              title="Seguro que quieres cancelar esta requisición"
              onConfirm={() => this.cancelarRequisicion(value._id)}
              okText="Si"
              cancelText="No"
              disabled={!puedeCancelar }
            >
              <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                  disabled={!puedeCancelar}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          if (value.finiquitada) {
            buttons.push(
              <Tag key={`finiquitada-${index}`} color="purple">Finiquitada</Tag>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Requisiciones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <>
                  <SegmentedItem
                    options={[{ label: 'Pendiente', value: 1 }, { label: 'Terminada', value: 3 }, { label: 'Cancelada', value: 4 }, { label: 'Todos', value: 5 }]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                      }
                      this.setState({ valor: value });
                    }}
                    value={this.state.valor}
                  />
                </>
              }
              {(this.state.requisicionesSeleccionadas.length > 0) &&
                <ButtonItem
                  blanco
                  icon={<DownloadOutlined />}
                  key="descargarRequisiciones"
                  onClick={this.abrirDescarga.bind(this)}
                >
                  Descargar ({this.state.requisicionesSeleccionadas.length})
                </ButtonItem>}
              {(this.state.requisicionesSeleccionadas.length > 0) &&
                <ButtonItem
                  type="primary"
                  blanco
                  key="agruparRequisiciones"
                  onClick={this.agruparRequisiciones.bind(this)}
                >
                  Agrupar Requisiciones
                </ButtonItem>}
              {this.props.permisoAgregarRequisiciones && 
                <ButtonItem
                  type="primary"
                  key="agregarRequisicion"
                  olivo
                  onClick={this.agregarRequisicion.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Requisición
                </ButtonItem>  
              }
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarRequisiciones.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          estadosLeyenda={[
            { color: '#C8FFBB', label: 'Baja', key: 'apartado' },
            { color: '#FFE7CF', label: 'Media', key: 'material-recibido' },
            { color: '#FFA39E', label: 'Alta', key: 'completo' },
            
          ]}
          dataSource={this.state.todasRequisiciones}
          columns={columns}
          scroll={{ x: "max-content" }} // o un número, p.ej. { x: 1400 }
          filterStorageKey={"requisicionesFiltrosTabla" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              this.verRequisicion(record.accion._id);
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorTextoDefault={""}
          rowSelection={{
            selectedRowKeys: this.state.requisicionesSeleccionadas,
            onChange: this.onSelectChange.bind(this),
            // La tabla pagina del lado del servidor: sin esto, antd tira las
            // llaves de las páginas anteriores al paginar.
            preserveSelectedRowKeys: true,
          }}
        />

        <ModalDescargarDocumentos
          visible={this.state.modalDescarga.visible}
          loading={this.state.modalDescarga.loading}
          progreso={this.state.modalDescarga.progreso}
          total={this.state.requisicionesSeleccionadas.length}
          tieneXml={MODULOS.requisicion.tieneXml}
          onClose={this.cerrarDescarga.bind(this)}
          onConfirm={this.confirmarDescarga.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    workbenchRequisiciones: state.empresa.workbenchRequisiciones,
    permisoGenerarOCReq: 
      state.user.tipo === 0 || 
      state.user.permisos.find(
        (valueTodos) => 
          valueTodos.permisoId.toString() === "647a17abbd6a695a9801702c"
      )?.activado,
    permisoAgregarRequisiciones: 
      state.user.tipo === 0 || 
      state.user.permisos.find(
        (valueTodos) => 
          valueTodos.permisoId.toString() === "647a1971bd6a695a9801702d"
      )?.activado, 
    permisoEditarRequisiciones: 
      state.user.tipo === 0 || 
      state.user.permisos.find(
        (valueTodos) => 
          valueTodos.permisoId.toString() === "647a1613bd6a695a98017029"
      )?.activado, 
    permisoCancelarRequisiciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647a1766bd6a695a9801702b"
      )?.activado,
    permisoCotizacionesRequisicion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9624686102bd5076d5e622"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Requisiciones);
